import CRUDMethods from '../../constants/CRUDConstants';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';

import {APIType, APITypeEnum} from './../interface/tableAPIType';

export const tableAPIMethod = (APIType: APIType): string => {
  switch (APIType) {
    case APITypeEnum.GET_ALL:
    case APITypeEnum.GET_ONE:
      return CRUDMethods.GET;
    case APITypeEnum.POST_NEW:
    case APITypeEnum.DELETE_ALL:
    case APITypeEnum.STATUS_ALL:
    case APITypeEnum.DELETE:
      return CRUDMethods.POST;
    case APITypeEnum.PUT:
      return CRUDMethods.PUT;
    case APITypeEnum.METHOD_DELETE:
      return CRUDMethods.DELETE;
    default:
      return CRUDMethods.GET;
  }
};

export const getRoute = (APIType: APIType, id: string): string => {
  const companyId = useCompanyStore.getState().companyId;
  switch (APIType) {
    case APITypeEnum.GET_ALL:
      return `company/${companyId}`;
    case APITypeEnum.GET_ONE:
    case APITypeEnum.PUT:
      return id;
    case APITypeEnum.METHOD_DELETE:
      return id;
    case APITypeEnum.POST_NEW:
      return '';
    case APITypeEnum.DELETE_ALL:
    case APITypeEnum.DELETE:
      return 'delete';
    case APITypeEnum.STATUS_ALL:
      return 'status';
    default:
      return '';
  }
};

export const getRouteIP = (APIType: APIType, id: string): string => {
  switch (APIType) {
    case APITypeEnum.GET_ALL:
      return id;
    case APITypeEnum.GET_ONE:
    case APITypeEnum.PUT:
      return id;
    case APITypeEnum.POST_NEW:
      return '';
    case APITypeEnum.DELETE_ALL:
    case APITypeEnum.DELETE:
      return 'delete';
    case APITypeEnum.STATUS_ALL:
      return 'status';
    default:
      return '';
  }
};

export const ESGRouteIP = (
  APIType: APIType,
  tabId: string,
  selectedYear: string,
  id: string
): string => {
  const companyId = useCompanyStore.getState().companyId;
  switch (APIType) {
    case APITypeEnum.GET_ALL:
      return `${companyId}/${tabId}/${selectedYear}`;
    case APITypeEnum.GET_ONE:
    case APITypeEnum.PUT:
      return id;
    case APITypeEnum.POST_NEW:
      return '';
    case APITypeEnum.DELETE_ALL:
    case APITypeEnum.DELETE:
      return 'delete';
    case APITypeEnum.STATUS_ALL:
      return 'status';
    default:
      return '';
  }
};
